<template>
  <RevContainer>
    <h2 class="text-static-default-hi heading-1 mb-4 flex md:justify-center">
      {{ i18n(translations.title) }}
    </h2>

    <PoliciesAndEligibleInsurances :policies />
  </RevContainer>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevContainer } from '@ds/components/Container'

import translations from './ServicesHub.translations'
import PoliciesAndEligibleInsurances from './pages/PoliciesAndEligibleInsurances/PoliciesAndEligibleInsurances.vue'
import type { Policy } from './type'

const i18n = useI18n()

// TODO Fetch policies
const policies: Policy[] = []
</script>
